'use client';

import { AuthCustomerService } from '@/layers/application/services/auth/customer/auth-customer.service';
import { emailSchema } from '@/shared/application/validation/schemas/profile/contact/email.schema';
import { CustomerForgotPasswordDto } from '@/shared/components/forms/auth/customer/dtos/customer-forgot-password.dto';
import { Button } from '@/shared/components/ui/button/button.component';
import { VerticalForm } from '@/shared/components/ui/form/vertical-form/vertical-form.component';
import { Input } from '@/shared/components/ui/input/input.component';
import { yupResolver } from '@hookform/resolvers/yup';
import { FC } from 'react';
import { useForm } from 'react-hook-form';
import { object } from 'yup';

/**
 * @todo Adicionar um toast com infos sobre a página, e remover o toast automaticamente qnd carregar outra página (usando sonner).
 */
export const CustomerForgotPasswordForm: FC = () => {
  const {
    register,
    handleSubmit,
    formState: { errors, isSubmitting },
  } = useForm<CustomerForgotPasswordDto>({
    resolver: yupResolver(
      object({
        email: emailSchema,
      }),
    ),
  });

  return (
    <VerticalForm
      id="form-forgot-password"
      onSubmit={handleSubmit(AuthCustomerService.forgotPassword())}
    >
      <Input
        id="input-email"
        label="E-mail"
        {...register('email')}
        error={
          errors.email?.message ? String(errors.email?.message) : undefined
        }
      />
      <Button
        id="button-forgot-password"
        form="form-forgot-password"
        type="submit"
        disabled={isSubmitting}
        loading={{ state: isSubmitting, children: 'Enviando...' }}
      >
        Solicitar recuperação
      </Button>
    </VerticalForm>
  );
};
